/*
angelCake v3.0 (http://angelcake.executiveresults.ca)
Copyright 2018 Executive Results
Licensed under the MIT license
*/


/* 
WRAPPER FOR multi.js and select2.js
*/


head.ready("appJS", function() {
  $(document).ready(function() {
    $('select:not(.no-select2)').each(function(){
      if($(this).prop('placeholder')){
        $(this).attr('data-placeholder',$(this).attr('placeholder'));
        
      }else{
        $(this).attr('data-placeholder', '');  //because select2 is dumb
      }
      $(this).attr('data-placeholder',$(this).attr('placeholder'));
      if($(this).prop('multiple')){
        var showSearch = false;
        if($(this).attr('data-show-search')==='true'){
          showSearch = true;
        }
        if($(this).attr('data-select-type')==='Inline'){
          //select2 here
            $(this).select2({
              placeholder: $(this).attr('data-placeholder'),
              allowClear: false,
              minimumResultsForSearch: 10
            });
          
          
        }else{
          //generate dual list box
          
          //angelCake.generateDualListBox is set in _multi.js
          angelCake.generateDualListBox(this, {
            'enable_search': showSearch,
            'search_placeholder': $(this).attr('data-placeholder'),
            'non_selected_header': $(this).attr('data-left-heading'),
            'selected_header': $(this).attr('data-right-heading')
          });
        }
      }else{
        $(this).select2({
          placeholder:$(this).attr('data-placeholder'),
          allowClear: false,
          minimumResultsForSearch: 10
        });
      }
    });


  });
});